module.exports = __webpack_public_path__ + "assets/img/87c146f9cd11d110e7a2e0252a264aae.webp";